module.exports = __webpack_public_path__ + "themes/mf/sound/audio-sprite.ogg";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/sound/audio-sprite.ogg
// module id = 49
// module chunks = 3